import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUSES } from '../data/bonuses';
import { scrollToBuy } from '../utils/constants';
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="w-full bg-white px-3 py-6 sm:px-5" data-id="element-23" data-mp="plsnad7r1gdg">
      <div className="mx-auto max-w-4xl" data-id="element-24" data-mp="at8vg8q1uvbb">
        <div className="text-center" data-id="element-25" data-mp="ftefb2q2vdiu">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-green/15 px-2.5 py-0.5 font-head text-[10px] uppercase tracking-wide text-green-dark sm:text-xs" data-id="element-26" data-mp="fsbsp6zsfx8q">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-27" data-mp="5wrx6lp4z0ki" />
            Also included at no extra cost
          </span>
          <h2 id="bonuses-title" className="mt-1 font-head text-2xl uppercase leading-none text-navy sm:text-4xl" data-id="element-28" data-mp="3o3g32ds0frr8">
            4 Strategic Bonuses
          </h2>
          <p className="mt-1 text-[13px] leading-snug text-muted" data-id="element-29" data-mp="1mb9y16ll9sm0">
            More ways to practice, reinforce and apply what children learn.
          </p>
        </div>

        <div className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-30" data-mp="3ie6ipjlba5wq">
          {BONUSES.map(bonus => <button key={bonus.number} type="button" onClick={scrollToBuy} aria-label={`Go to the purchase section — ${bonus.title}`} className={`flex flex-col rounded-xl border border-line border-l-4 bg-soft p-3 text-left transition-colors duration-150 ease-out hover:border-navy/40 ${bonus.border}`} data-id="element-31" data-mp="3ic3iy7ucwyet">
              <span className={`inline-flex w-fit items-center rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-widest text-white ${bonus.accent}`} data-id="element-32" data-mp="2zfkf9y2bo2pn">
                Bonus {bonus.number}
              </span>
              <span className="mt-1 block font-head text-base uppercase leading-tight text-navy sm:text-lg" data-id="element-33" data-mp="38gs29jze1h4f">
                {bonus.title}
              </span>
              <span className="mt-0.5 block text-[11px] font-bold uppercase leading-snug tracking-wide text-blue" data-id="element-34" data-mp="33ja3gmf34ia5">
                {bonus.subtitle}
              </span>
              <span className="mt-1 block text-[12px] leading-snug text-muted sm:text-[13px]" data-id="element-35" data-mp="iq57l115ddde">
                {bonus.body}
              </span>
              <span className="mt-auto block pt-1.5 text-[10px] font-bold uppercase leading-snug tracking-wide text-navy" data-id="element-36" data-mp="3hhzlbf3gi5cc">
                {bonus.tags}
              </span>
            </button>)}
        </div>
      </div>
    </section>;
}